// src/hooks/useCurrentModule.ts
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export const useCurrentModule = () => {
  const location = useLocation();
  const modules = useSelector((state: any) => state.user?.modules || []);
  const moduleUrl = location.pathname.split('/')[1];
  const currentModule = modules.find((mod: any) => mod.module_url === moduleUrl);

  return currentModule || null;
};
